import { MapPin } from "lucide-react";

export default function MapSection() {
  return (
    <section
      id="localizacao"
      data-testid="map-section"
      className="py-24 sm:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
            Localizacao
          </div>
          <h2
            data-testid="map-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Onde <span className="text-[#FFD700]">estamos</span>
          </h2>
          <div className="flex items-center justify-center gap-2 text-gray-300 mt-4">
            <MapPin className="w-5 h-5 text-[#FFD700]" />
            <span className="text-base">Rua Peru, 270 - Navirai/MS</span>
          </div>
        </div>

        {/* Map */}
        <div className="map-wrapper overflow-hidden rounded-sm" data-testid="google-map">
          <iframe
            title="Localizacao Huck Guincho 24HS"
            src="https://maps.google.com/maps?q=Rua+Peru+270+Navirai+MS+Brasil&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          />
        </div>
      </div>
    </section>
  );
}
